/*
 * @Descripttion:
 * @Author: voanit
 * @Date: 2021-04-25 13:45:18
 * @LastEditors: voanit
 * @LastEditTime: 2022-03-09 19:27:16
 */
import { request } from '@/utils/request'
export function dicList(params) {
  return request({
    url: '/sgsf-common-interface/dicts',
    method: 'get',
    params
  })
}

// 2.2. 通过类型获取字典列表(批量)
export function getDictLists(params) {
  return request({
    url: '/sgsf-common-interface/dicts/batch',
    method: 'get',
    params
  })
}
//根据密文获取解密数据
export function encryptKey(params) {
  return request({
    url: '/sgsf-platform/sys-users/encrypt-properties',
    method: 'get',
    params
  })
}
